<template lang="pug">
  div.body.body-table.bank-books-operations
    div.table-choose-panel
      div.operation-information
        div.toolbar-table
          div.select.list Информация по счету

          div.toolbar.toolbar--modal
            div.line
              div.actions-panel
                e-button-add(
                label="Начисление"
                @click="openCreateOperationModal()"
                )

                e-button-edit(
                label="Перерасчет"
                @click="openRecaclOperationModal()"
                )

                e-button-edit(
                label="Перерасчет пени"
                @click="openRecaclFineModal()"
                )

              div.parameters.filter-separator
                e-year-selector(
                year="year"
                placeholder="Год"
                :disablePlaceholderOption="false"
                )
                e-select-month(
                month="month"
                placeholder="Месяц"
                :disablePlaceholderOption="false"
                )
              div.actions-panel
                button(
                type="button"
                @click.stop.prevent="applyFilters()"
                ).actions-panel__button Применить

              div.parameters.filter-separator
                button(
                @click="expandAllOperation()"
                ).actions-panel__button {{allOperationIsExpanded ? 'Закрыть все' : 'Раскрыть все'}}

        div
          e-table-inner(
          ref="operationInformationTable"
          :itemsEndpoint="operationInformationEndpoint"
          :parallelFetchData="parallelFetchData"
          :afterFetchData="afterFetchData"
          :showDeleteButton="false"
          :eventsStreamName="eventsStreamName"
          id-key-name="period"
          :canOpenRow="canOpenRow"
          :enableInnerPagination="false"
          )
            template(
              slot="period"
              slot-scope="{row, toggleRow, isExpanded}"
            )
              div(v-if="row.disableExpand") {{row.period}}
              div(
                v-else
                @click.stop.prevent="toggleRow(row)"
                :class="getItemClass(isExpanded)"
              ).with-actions
                span.arrow
                span {{row.period}}

            div(slot="expandedRow" slot-scope="{row}")
              e-table-inner(
              :itemsEndpoint="decorateOperationEndpoint(row)"
              :showDeleteButton="false"
              :eventsStreamName="eventsStreamName"
              :enableInnerPagination="false"
              )

      div.operation

        operation-create(
        v-if="createOperationModalShowed"
        @close="createOperationModalShowed=false"
        @updated="reFetchData()"
        :model="model"
        )

        operation-recalc(
        v-if="recalcOperationModalShowed"
        @close="recalcOperationModalShowed=false"
        @updated="reFetchData()"
        :model="model"
        )

        operation-recalc-fine(
        v-if="recalcFineModalShowed"
        @close="recalcFineModalShowed=false"
        @updated="reFetchData()"
        :model="model"
        )

</template>

<script>
  import {wasteGenerators} from "../../../api/api-endpoints"
  import OperationCreate from "./operation-create"
  import OperationRecalc from "./operation-recalc";
  import {LEVEL_CSS_CLASS_MAP} from "../../../config/config"
  import {url} from "../../../utils/url"
  import OperationRecalcFine from "./operation-recalc-fine";

  const filterModel = {}

  export default {
    name: 'bank-books-operations',
    components: {OperationRecalcFine, OperationRecalc, OperationCreate},
    props: {
      model: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      createOperationModalShowed: false,
      recalcOperationModalShowed: false,
      recalcFineModalShowed: false,
      allOperationIsExpanded: false,
      year: '',
      month: ''
    }),
    computed: {
      tabView () {
        return this.$route.query.tabView
      },
      eventsStreamName () {
        return 'bank-books-operations-inner-tables'
      }
    },
    created () {
      this.year = this.$route.query.year || ''
      this.month = this.$route.query.month || ''
      this.syncFilterModel()
    },
    methods: {
      canOpenRow (row) {
        return !!row.disableExpand === false
      },
      applyFilters () {
        this.syncFilterModel()
        this.syncRouteWithFilterModel()
        if (this.$refs.operationInformationTable) {
          this.$refs.operationInformationTable.updateTable()
        }
      },
      syncFilterModel () {
        filterModel.year = this.year
        filterModel.month = this.month
      },
      syncRouteWithFilterModel () {
        const path = url.getRoute(this.$route)
        path.query = {
          ...path.query,
          ...filterModel
        }
        this.$router.replace(path)
      },
      expandAllOperation () {
        if (this.$refs.operationInformationTable && this.$refs.operationInformationTable.items) {
          const items = this.$refs.operationInformationTable.items
          items.data.forEach(row => {
            if (this.allOperationIsExpanded) {
              this.$refs.operationInformationTable.closeRow(row)
            } else {
              this.$refs.operationInformationTable.openRow(row)
            }
          })
          this.allOperationIsExpanded = !this.allOperationIsExpanded
        }
      },
      getItemClass (isExpanded) {
        return [
          LEVEL_CSS_CLASS_MAP[1],
          isExpanded ? 'open' : 'close'
        ]
      },
      reFetchData () {
        this.$emitter.emit(this.eventsStreamName, {
          action: 'updateTable'
        })
      },
      decorateOperationEndpoint (row) {
        return (ctx) => {
          return this.operationEndpoint(ctx, row)
        }
      },
      operationEndpoint (ctx, row) {
        let url = null
        if (this.model.id) {
          let route = {
            query: {
              operation_period: row.period || null,
              sort: ctx.currentSort || null,
              // page: ctx.paginateObj ? ctx.paginateObj.page : null,
              'per-page': -1 // ctx.paginateObj ? ctx.paginateObj['per-page'] : null
            }
          }
          url = wasteGenerators.bankBookOperations(this.model.id, route)
        }
        return { url }
      },
      operationInformationEndpoint (ctx) {
        let url = null
        if (this.model.id) {
          let route = {
            query: {
              ...filterModel,
              sort: ctx.currentSort || null,
              // page: ctx.paginateObj ? ctx.paginateObj.page : null,
              'per-page': -1 // ctx.paginateObj ? ctx.paginateObj['per-page'] : null
            }
          }

          url = wasteGenerators.bankBookOperationInformations(this.model.id, route)
        }
        return {
          url
        }
      },
      operationInformationTotalEndpoint () {
        return wasteGenerators.bankBookOperationInformationsTotal(
          this.model.id,
          {query: {...filterModel}}
        )
      },
      openCreateOperationModal () {
        this.createOperationModalShowed = true
      },
      openRecaclOperationModal () {
        this.recalcOperationModalShowed = true
      },
      openRecaclFineModal () {
        this.recalcFineModalShowed = true
      },
      parallelFetchData () {
        return this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.operationInformationTotalEndpoint(),
          params: {
            disableGlobalError: true
          }
        })
      },
      afterFetchData (ctx, data, [_, totalResponse]) {
        console.log('total fetch', data.data, _, totalResponse)

        // summary all values to total row
        const items = data.data.slice()
        const {data: {data: [firstRow]}} = totalResponse
        if (firstRow) {
          firstRow.period = 'Всего'
          firstRow.disableExpand = true
          items.unshift(firstRow)
        }

        return Object.assign({}, {
          data: items,
          _meta: data._meta
        })
      }
    }
  }
</script>
